import React, { useRef } from 'react';
const ExternalWorkersRowHeader = _ref => {
  let {
    claim,
    setHeaderScrollPosition,
    isShowInvolvement,
    allProjects
  } = _ref;
  const reportsHeaderRef = useRef(null);
  const onHeaderScroll = e => {
    setHeaderScrollPosition(e.target.scrollLeft);
  };
  const showInvolvementHeader = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "border-start cost_categories_subpage_header_cell"
    }, "Involvement"), /*#__PURE__*/React.createElement("div", {
      className: "border-start cost_categories_subpage_header_cell"
    }, "Qualifying", /*#__PURE__*/React.createElement("br", null), " Expenditures"));
  };
  const showRndHeader = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "border-start cost_categories_subpage_header_cell"
    }, "Direct R&D%"), /*#__PURE__*/React.createElement("div", {
      className: "border-end cost_categories_subpage_header_cell"
    }, "Months"));
  };
  const ReportSubheader = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "d-flex"
    }, allProjects.map((report, index) => {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "bg-primary text-white border-start border-end cost_categories_subpage_header_cell_container"
      }, report.project_name || 'Unnamed Project');
    })), /*#__PURE__*/React.createElement("div", {
      className: "d-flex"
    }, allProjects.map((_, index) => {
      return /*#__PURE__*/React.createElement("div", {
        className: "d-flex cost_categories_subpage_header_cell_container",
        key: index
      }, isShowInvolvement ? showInvolvementHeader() : showRndHeader());
    })));
  };
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Name"), /*#__PURE__*/React.createElement("th", null, "Paye Number"), /*#__PURE__*/React.createElement("th", null, "Description of Activity"), /*#__PURE__*/React.createElement("th", null, "Staff Provider"), /*#__PURE__*/React.createElement("th", null, "Total Amount"), /*#__PURE__*/React.createElement("th", null, "Capitalised Amount"), /*#__PURE__*/React.createElement("th", null, "EPW Confirmation"), /*#__PURE__*/React.createElement("th", null, "Connected Party"), isShowInvolvement && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("th", null, "Direct R&D %"), /*#__PURE__*/React.createElement("th", null, "Indirect R&D %"), /*#__PURE__*/React.createElement("th", null, "R&D %")), claim.claim_group.project_methodology === 'project_basis' ? /*#__PURE__*/React.createElement("th", null, /*#__PURE__*/React.createElement("div", {
    ref: reportsHeaderRef,
    onScroll: onHeaderScroll,
    className: "cost_categories_subpage_header"
  }, /*#__PURE__*/React.createElement(ReportSubheader, null))) : null, !isShowInvolvement && /*#__PURE__*/React.createElement("th", null, "R&D %"), /*#__PURE__*/React.createElement("th", null, "Allocation"), /*#__PURE__*/React.createElement("th", null, "R&D Amount"), /*#__PURE__*/React.createElement("th", null, "P&L R&D Expenditure"), /*#__PURE__*/React.createElement("th", null, "S1308 Claim"));
};
export default ExternalWorkersRowHeader;